import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { GamificationSpinWheel } from "@/pages/perkpoint/gamification/GamificationSpinWheel";
import { GamificationScratchCard } from "@/pages/perkpoint/gamification/GamificationScratchCard";
import { GamificationAnalytics } from "@/pages/perkpoint/gamification/GamificationAnalytics";
import { GamificationAllSpinWheels } from "@/pages/perkpoint/gamification/GamificationAllSpinWheels";
import { GamificationAllScratchCards } from "@/pages/perkpoint/gamification/GamificationAllScratchCards";
import { GamificationReport } from "@/pages/perkpoint/gamification/GamificationReport";
import { GamificationAllQuizzes } from "@/pages/perkpoint/gamification/GamificationAllQuizzes";
import { GamificationAllSlotMachines } from "@/pages/gamepoint/slotmachine/GamificationAllSlotMachines";
import { GamificationAllMysteryBoxes } from "@/pages/gamepoint/mysterybox/GamificationAllMysteryBoxes";

export default function GamePointGamification() {
  const { pathname } = useLocation();
  const [spinTab, setSpinTab] = useState("spin");
  const [scratchTab, setScratchTab] = useState("scratch");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Gamification</h1>
          <p className="text-muted-foreground">
            Manage gamification features and activities
          </p>
        </div>
      </div>

      <div className="w-full space-y-6">
          {pathname === "/gamepoint/analytics" && (
            <GamificationAnalytics />
          )}

          {pathname === "/gamepoint/spin-a-wheel" && (
            <Tabs value={spinTab} onValueChange={setSpinTab} className="w-full">
              <TabsList className="grid w-full max-w-md grid-cols-2">
                <TabsTrigger value="spin">Spin a wheel</TabsTrigger>
                <TabsTrigger value="all">All Spin wheels</TabsTrigger>
              </TabsList>
              <TabsContent value="spin" className="mt-6 space-y-6">
                <GamificationSpinWheel />
              </TabsContent>
              <TabsContent value="all" className="mt-6 space-y-6">
                <GamificationAllSpinWheels />
              </TabsContent>
            </Tabs>
          )}

          {pathname === "/gamepoint/scratch-card" && (
            <Tabs
              value={scratchTab}
              onValueChange={setScratchTab}
              className="w-full"
            >
              <TabsList className="grid w-full max-w-md grid-cols-2">
                <TabsTrigger value="scratch">Scratch Card</TabsTrigger>
                <TabsTrigger value="all">All Scratch card</TabsTrigger>
              </TabsList>
              <TabsContent value="scratch" className="mt-6 space-y-6">
                <GamificationScratchCard />
              </TabsContent>
              <TabsContent value="all" className="mt-6 space-y-6">
                <GamificationAllScratchCards />
              </TabsContent>
            </Tabs>
          )}

          {pathname === "/gamepoint/slot-machine" && (
            <div className="space-y-6">
              {/* Slot Machine play tab hidden until ready — restore Tabs when adding back */}
              <GamificationAllSlotMachines />
            </div>
          )}

          {pathname === "/gamepoint/mystery-box" && (
            <div className="space-y-6">
              <GamificationAllMysteryBoxes />
            </div>
          )}

          {pathname === "/gamepoint/quiz" && (
            <div className="space-y-6">
              <GamificationAllQuizzes />
            </div>
          )}

          {pathname === "/gamepoint/report" && (
            <div className="space-y-6">
              <GamificationReport />
            </div>
          )}
      </div>
    </div>
  );
}
